import { useLocalStorage } from 'usehooks-ts'

/**
 * Hook to manage the "provider-business-hours-disclaimer-seen" local storage state.
 * This is used to track whether the provider has seen the business hours disclaimer.
 * It gets reset on each login.
 */
export default function useProviderBusinessHoursDisclaimerSeen() {
  return useLocalStorage('provider-business-hours-disclaimer-seen', false)
}
